

function toWords (text) {
    const words = text.split(/\s+/g);
    if (!words[words.length-1]) words.pop();
    if (!words[0]) words.shift();
    return words;
}

const ctx = document.createElement('canvas').getContext('2d');
const body = document.querySelector('body');
ctx.font = getComputedStyle(body ).font;

export function fitText(rawText, maxWidth) {
    const words = toWords(rawText);

    if (!words.length) return [];

    const measureWidth = text => ctx.measureText(text).width;

    return words.slice(1).reduce(
        (lines, word) => {
            const currentLine = lines[lines.length - 1] + " " + word;
            if (measureWidth(currentLine) < maxWidth) {
                lines[lines.length - 1] = currentLine;
            } else {
                lines.push(word);
            }
            return lines;
        },
        [words[0]] // lines string[]
    )
}
